import { useGetFormRecoil } from "../formDetail.service";
import ParseHTMLContent from "../../../../components/ParseHTMLContent/ParseHTMLContent";
import "./formsHeader.scss";

export const FormHeader = () => {
	const { form } = useGetFormRecoil();
	const formattedDate = form?.updatedAt ? new Date(form.updatedAt).toLocaleDateString("en-US") : "";
	const estimatedTime = "10 minutes"; // @TODO: get estimated time from form?

	return (
		<div className="detailHeader-info formHeader">
			<div className="formHeader-titleRow">
				{form?.logoUrl && (
					<img
						className="formHeader-logo"
						src={form.logoUrl}
						alt={`${form?.name ?? "Form"} logo`}
						onError={(event) => {
							event.currentTarget.style.display = "none";
						}}
					/>
				)}
				<h1>{form?.name && <ParseHTMLContent htmlString={form.name} />}</h1>
			</div>
			{/* TODO: add description back in when requested by design */}
			{/* {form?.description && (
				<p className="formHeader-description">
					<ParseHTMLContent htmlString={form.description} />
				</p>
			)} */}
			<p>
				{/* <span>{FormDetailData.organizationName}</span> */}
				<span>
					Last Updated: <span className="thin">{formattedDate}</span>
				</span>
				<span>
					Estimated Time to Complete: <span className="thin">{estimatedTime}</span>
				</span>
			</p>
		</div>
	);
};
